export const GET_MEMBER_INFO = 'GET_MEMBER_INFO';
export const INSERT_CONSULTING = 'INSERT_CONSULTING';



// WEBPACK FOOTER //
// ./src/constants/consulting.js